import type { ReactNode } from 'react';
import styled from 'styled-components';

export const TableOfContentsWrapper = styled.div`
  padding: 20px 0;
  margin: 20px 0;
`;

export const Ol = styled.ol<{
  children: ReactNode;
  id: string;
  rowsNumber: number;
}>`
  margin-top: 30px;
  counter-reset: my-awesome-counter;
  list-style: none;
  font-family: Roboto, Helvetica, sans-serif;

  &#tableOfContentsList {
    padding-left: 30px;

    li {
      margin-bottom: 16px;
      padding: 0;

      @media ${({ theme }) => theme.media.desktop} {
        margin: 0;
      }
    }
  }

  @media ${({ theme }) => theme.media.desktop} {
    display: grid;
    grid-template-rows: repeat(${({ rowsNumber }) => rowsNumber}, 1fr);
    grid-column-gap: 40px;
    grid-row-gap: 8px;
    grid-auto-flow: column;
  }

  li {
    counter-increment: my-awesome-counter;
    position: relative;
    padding: 5px 0;

    &::before {
      content: counter(my-awesome-counter);
      color: white;
      font-size: 12px;
      font-weight: bold;
      position: absolute;
      left: -32px;
      background: ${({ theme }) => theme.palette.secondary};
      text-align: center;
      padding: 5px;
      width: 14px;
      height: 14px;
      line-height: 13px;
      border-radius: 3px;
      top: -2px;
    }
  }

  a {
    color: ${({ theme }) => theme.palette.dark};

    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      padding-left: 32px;
      transform: translateX(-32px);
    }

    &:hover {
      color: ${({ theme }) => theme.palette.primary};
    }
  }
`;
